import LiveInputsService from '@app/application/reconciliation/services/live-inputs-service'
import { SfLog } from '@app/adapters/logger'

export default () => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const elements = doc.querySelectorAll(
      "[data-behaviour='external-company-selector-modal']"
    )

    elements.forEach((el) => {
      el.addEventListener('click', () => {
        const {
          name,
          objectId,
          objectType,
          objectLedgerId,
          value,
          valueType,
          defaultValue,
          singleSelection,
        } = el.dataset

        const parent = el.closest('[data-behaviour="live-inputs"]')

        const parentdataset = parent.dataset
        const updatePath = parentdataset.createPropertiesPath
        const ownerType = parentdataset.ownerType
        const ownerId = parentdataset.ownerId
          ? parseInt(parentdataset.ownerId)
          : null
        const ledgerId = parentdataset.ledgerId
          ? parseInt(parentdataset.ledgerId)
          : null

        if (
          !objectId ||
          !objectType ||
          !objectLedgerId ||
          !valueType ||
          !ownerType ||
          !updatePath ||
          !ownerId
        ) {
          return
        }

        const updateParams = {
          ledgerId,
          name,
          objectId: parseInt(objectId),
          objectType,
          objectLedgerId: parseInt(objectLedgerId),
          [ownerType]: ownerId,
          valueType,
        }

        const liveInputsService = LiveInputsService()

        if (!liveInputsService.instance) {
          SfLog.info('LiveInputs::Missing LiveInputs instance', {
            extra: {
              ...window.Silverfin.jsonParams,
            },
          })
          return
        }

        const dataToSubmit = liveInputsService.instance.dataToSubmit

        const modalParams = {
          updatePath,
          updateParams,
          value,
          defaultValue,
          singleSelection,
          dataToSubmit,
          afterUpdate: (response) => {
            liveInputsService.instance.replaceHtml(response)
            liveInputsService.instance.liveValidationHandlers.forEach(
              (handler) => handler()
            )
            liveInputsService.instance.showUndo(response.auditIds)
            liveInputsService.instance.clearDataToSubmit()
          },
        }

        window.modalCitizen.openModalPortal(
          'external-company-selector-modal',
          modalParams
        )
      })
    })
  })
}
